import i18n from '../i18n/config';

// Get current language from data-locale attribute, URL, or default to 'lv'
export const getCurrentLanguage = (): string => {
  // First, try to get locale from data-locale attribute (set by Rails controller)
  if (typeof document !== 'undefined') {
    const body = document.body;
    if (body && body.dataset.locale) {
      return body.dataset.locale;
    }
  }
  
  // Fallback to URL parsing
  const pathParts = window.location.pathname.split('/').filter(Boolean);
  const supportedLocales = ['lv', 'en', 'ru'];
  return supportedLocales.includes(pathParts[0]) ? pathParts[0] : 'lv';
};

// Translation helper function
export const t = (key: string, options: Record<string, any> = {}): string => {
  if (typeof window !== 'undefined' && (window as any).I18n) {
    const I18n = (window as any).I18n;
    const locale = getCurrentLanguage();
    
    // Set the current locale
    I18n.locale = locale;
    
    try {
      return I18n.t(key, options);
    } catch (error) {
      console.warn(`Translation missing for key: ${key}`, error);
      return key;
    }
  }
  
  // Fallback if I18n is not available
  console.warn(`I18n not available for key: ${key}`);
  return key;
};

// Get current locale
export const getCurrentLocale = (): string => {
  return getCurrentLanguage();
};

// Set locale
export const setLocale = (locale: string): void => {
  if (typeof window !== 'undefined' && (window as any).I18n) {
    (window as any).I18n.locale = locale;
    // Also update HTML lang attribute
    document.documentElement.lang = locale;
  }
};

// Check if translation exists
export const hasTranslation = (key: string): boolean => {
  if (typeof window !== 'undefined' && (window as any).I18n) {
    try {
      const result = (window as any).I18n.t(key);
      return result !== key; // If translation exists, it should return something different than the key
    } catch (error) {
      return false;
    }
  }
  return false;
};

export default i18n;
